import { render, staticRenderFns } from "./AddressBuyer.vue?vue&type=template&id=2ebf2d08"
import script from "./AddressBuyer.vue?vue&type=script&lang=js"
export * from "./AddressBuyer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports